import { render, staticRenderFns } from "./PDFServiceProtocol.vue?vue&type=template&id=fbf83e2c&scoped=true&"
import script from "./PDFServiceProtocol.vue?vue&type=script&lang=js&"
export * from "./PDFServiceProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PDFServiceProtocol.vue?vue&type=style&index=0&id=fbf83e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf83e2c",
  null
  
)

export default component.exports